var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "breadcrumbs__container" }, [
    _c(
      "div",
      { staticClass: "breadcrumbs__wrapper" },
      [
        _vm._l(_vm.prevPages, function (page, ind) {
          return _c(
            "nuxt-link",
            {
              key: ind,
              staticClass: "breadcrumbs__page",
              attrs: { to: _vm.localePath(page.link) },
            },
            [_vm._v("\n      " + _vm._s(page.label) + "\n    ")]
          )
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "breadcrumbs__page breadcrumbs__page_current" },
          [_vm._v("\n      " + _vm._s(_vm.currentPage.label) + "\n    ")]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }